import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";

import { PreviewDrawerLineStyled } from "@ryde/controls";
import { rydeColors } from "@ryde/theme";

import { ProcessDrawerContext } from "../process-drawer-context";

export const ProcessStatsFunnel: FC = () => {
  const { t } = useTranslation();
  const { currentProcess } = useContext(ProcessDrawerContext);

  const stats = currentProcess?.metadata?.stats;

  if (!stats) {
    return null;
  }

  return (
    <>
      <PreviewDrawerLineStyled $numberColor={rydeColors.grey}>
        <span>{t("process.statsTotalSelected")}</span>
        <span>{stats.totalSelected}</span>
      </PreviewDrawerLineStyled>
      <PreviewDrawerLineStyled $numberColor={rydeColors.grey}>
        <span>{t("process.statsWithTrackingProvider")}</span>
        <span>{stats.withTrackingProvider}</span>
      </PreviewDrawerLineStyled>
      <PreviewDrawerLineStyled $numberColor={rydeColors.green}>
        <span>{t("process.statsWithValidPlate")}</span>
        <span>{stats.withValidPlate}</span>
      </PreviewDrawerLineStyled>
    </>
  );
};
